import * as model from './model.js';
import recipeView from './views/recipeView.js';
import searchView from './views/searchView.js';
import resultView from './views/resultView.js';
import paginationView from './views/paginationView.js';
import bookmarkView from './views/bookmarkView.js';
import addRecipeView from './views/addRecipeView.js';
import { SUCCESS_MSG_DELAY_SEC } from './config.js';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

///////////////////////////////////////

async function controlRecipe() {
  try {
    // Getting ID
    const recipeID = window.location.hash.slice(1);
    if (!recipeID) return;

    recipeView.renderSpinner();
    // Loading recipe
    await model.loadRecipe(recipeID);

    // updating bookmarks
    bookmarkView.update(model.state.bookmark);

    // Rendering recipe
    recipeView.render(model.state.recipe);

    // Update choosed preciew
    resultView.update(model.getSearchResultPage());
  } catch (err) {
    console.error(`Error ==> ${err}`);
    recipeView.renderError();
  }
}

async function controlSearchResult() {
  try {
    // Getting query

    const query = searchView.getQuery();
    if (!query) return;

    resultView.renderSpinner();
    // Load search result
    await model.loadSearchResult(query);

    resultView.render(model.getSearchResultPage());
    paginationView.render(model.state.search);
  } catch (err) {
    resultView.renderError();
    paginationView.render(model.state.search);
    console.error(err);
  }
}

function controlPagination(page) {
  resultView.render(model.getSearchResultPage(page));
  paginationView.render(model.state.search);
}

function controlServings(newServings) {
  model.updateServings(newServings);

  recipeView.update(model.state.recipe);
}

function controlBookmark() {
  if (model.state.recipe.bookmarked)
    model.removeBookmark(model.state.recipe.id);
  else model.addBookmark(model.state.recipe);

  bookmarkView.render(model.state.bookmark);
  recipeView.update(model.state.recipe);
}

async function controlAddRecipe(data) {
  try {
    addRecipeView.renderSpinner();
    await model.uploadRecipe(data);
    addRecipeView.renderMessage();

    setTimeout(function () {
      addRecipeView.hideWindow();
      setTimeout(_ => window.location.reload(), 200);
    }, SUCCESS_MSG_DELAY_SEC * 1000);
    model.addBookmark(model.state.recipe);
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
  } catch (err) {
    addRecipeView.renderError(err);
    console.error(`Error ==> ${err}`);
  }
}

function init() {
  recipeView.addHandlerRender(controlRecipe);
  recipeView.addHandlerServingsUpdate(controlServings);
  recipeView.addHandlerBookmark(controlBookmark);
  searchView.addHandlerSearch(controlSearchResult);
  paginationView.addHandlerPagination(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
}
init();
